<template>
  <PageTemplate>
    <h6 class="element-header">
      {{ $t('dashboard.dashboard_for') + piniaUserStore().currentUser?.user?.userAccessRightsTranslation }}
    </h6>

    <Menu/>

    <div class="element-box mt-4">
      <h5 class="form-header mb-4">
        Vorschau Einheiten - {{ coachingTypeShow[ filters.coachingType ] }}
      </h5>

      <div class="row">
        <div class="col-md-2">
          <SelectVue
              v-model="filters.coachingType"
              :options="dropdownCoachingType"
              :is-clear="false"
          />
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <SelectVue
              v-model="filters.year"
              :options="dropdownYears"
              :is-clear="true"
          />
        </div>
        <div class="col-lg-2 col-md-5 col-sm-12">
          <SelectVue
              v-model="filters.month"
              :placeholder="$t('general.month')"
              :options=" monthsInYear || []"
              :is-clear="true"
          />
        </div>
        <div class="col-lg-3 col-md-5 col-sm-12">
          <SelectVue
              :placeholder="$t('general.locations')"
              v-model="filters.locationId"
              :options="dropdownOffices"
              :is-clear="true"
          />
        </div>
        <div class="col-auto text-center">
          <SearchButton
              :label="$t('general.button.search')"
              :loading="isSearching"
              @click="getPotentialUnitsData(1)"/>
        </div>
      </div>
      <div class="row align-items-center mt-3">
        <div class="col">
          <PerPage
              :values="[10, 25, 50, 100]"
              @update:perPage="getPotentialUnitsData"/>

          <ExcelExportButton
              :label="$t('general.excel_export')"
              :loading="isExcelLoaded"
              @click="getExcelExport"/>
        </div>
      </div>

      <div class="table-responsive overflow-auto mt-3">
        <table class="table table-striped">
          <thead>
          <tr>
            <th>
              {{ $t('general.location') }}
            </th>
            <th class="text-start" style="width: 10%">
              {{ $t('general.month') }}
            </th>
            <th class="text-end" style="width: 10%">
              {{ $t('general.year') }}
            </th>
            <th class="text-end" style="width: 15%">
              Vorschau Einheiten
            </th>
            <th class="text-end" style="width: 15%">
              Abgehaltene Einheiten
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(data, index) in potentitalUnitsData.data" :key="index">
            <td class="text-start">
              <strong class="js-lists-values-employee-name">{{ data?.location }}</strong>
            </td>
            <td class="text-start">
              <strong class="js-lists-values-employee-name">{{ $t('calendar.months.' + data?.monthName) }}</strong>
            </td>
            <td class="text-end">
              <strong class="js-lists-values-employee-name">{{ data?.year }}</strong>
            </td>
            <td class="text-end">
              <strong class="js-lists-values-employee-name">{{ data?.potentialUnits }}</strong>
            </td>
            <td class="text-end">
              <strong class="js-lists-values-employee-name">{{ data?.unitsDone }}</strong>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <Pagination
          v-if="potentitalUnitsData?.pagination?.total_pages > 1"
          :totalPages="potentitalUnitsData?.pagination?.total_pages"
          :currentPage="potentitalUnitsData?.pagination?.current_page"
          @pagechanged="getPotentialUnitsData"
      />
    </div>
  </PageTemplate>
</template>

<script setup>
import dashboardAccountantService from '@/api/Dashboard/Accountant';
import ExcelExportButton from '@/components/ExcelExportButton.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import SearchButton from '@/components/button/SearchButton.vue';
import SelectVue from '@/components/SelectVue.vue';
import { ErrorToast } from '@/components/VueToast';
import { getOfficeDropdown, getYears } from '@/shared/dropdowns';
import { downloadFile } from '@/shared/functions';
import { piniaEnumsStore } from '@/store/piniaEnumsStore';
import { piniaUserStore } from '@/store/piniaUserStore';
import Menu from '@/views/App/Dashboard/Accountant/Menu.vue';
import { computed, onMounted, ref } from 'vue';

const filters = ref({
  coachingType: 'private_coaching',
  year: new Date().getFullYear(),
});

const { enums }        = piniaEnumsStore();
const { monthsInYear } = computed(() => enums).value;

const dropdownYears        = ref([]);
const dropdownCoachingType = ref([
  { value: 'private_coaching', label: 'Einzelcoaching' },
  { value: 'assisted_living_coaching', label: 'Betreutes Wohnen' },
]);
const coachingTypeShow     = {
  private_coaching: 'Einzelcoaching',
  assisted_living_coaching: 'Betreutes Wohnen',
};

const dropdownOffices     = ref([]);
const potentitalUnitsData = ref({});
const isSearching         = ref(false);
const isExcelLoaded       = ref(false);

async function getExcelExport() {
  await downloadFile('/dashboard/admin/potential-units-excel-export',
      undefined, {...filters.value}, false, 'GET', isExcelLoaded)
}

function getDropdowns() {
  getYears(dropdownYears);
  // getCoachingTypes(dropdownCoachingType);
  getOfficeDropdown(dropdownOffices);
}

async function getPotentialUnitsData(page = 1, perPage) {
  try {
    isSearching.value         = true;
    const { data }            = await dashboardAccountantService.getPotentialUnitsData({
      ...filters?.value,
      page: page ?? potentitalUnitsData.value?.pagination?.current_page,
      limit: perPage ?? potentitalUnitsData.value?.pagination?.items_per_page,
    });
    potentitalUnitsData.value = data;
    isSearching.value         = false;
  } catch (error) {
    isSearching.value = false;
    await ErrorToast(error);
  }
}

onMounted(() => {
  getPotentialUnitsData();
  getDropdowns();
});

</script>

<style scoped>

</style>